import {
    getPersona,
    listPersonas
} from './queries';
import {
    createPersona,
    deletePersona,
    updatePersona,
} from './mutations';

import { GraphQLQuery } from 'aws-amplify/api';
import {
    CreatePersona,
    DeletePersona,
    GetPersona,
    ListPersonas,
    Persona,
    UpdatePersona
} from "../types.ts";
import {
    showErrorNotifications,
    showSuccessNotification
} from "../../../components/ServiceNotifications.tsx";
import {config} from "../config";
import { client } from '../../email-api-integration';

export const fetchRecords = async ({
    limit = 10,
    nextToken = null,
    statusFilter = null
}: {
    limit?: number,
    nextToken?: string | null,
    statusFilter?: string | null
} = {}) => {
    const filter = statusFilter ? { status: statusFilter } : undefined;
    try {
        const response = await client.graphql<GraphQLQuery<ListPersonas>>({
            query: listPersonas,
            variables: {
                filter,
                limit: limit,
                nextToken: nextToken
            },
        });
        const result = {
            items: response.data?.listPersonas.items || [],
            nextToken: response.data?.listPersonas.nextToken || null
        };
        
        if (result.items.length === 0) {
            return { items: [], nextToken: null };
        }
        
        return result;
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e);
        return { items: [], nextToken: null };
    }
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetPersona>>({
        query: getPersona,
        variables: {id: id},
    });
    return response.data?.getPersona;
};

export const add = async (payload: Persona) => {

    try {
        const response = await client.graphql<GraphQLQuery<CreatePersona>>({
                                                                               query: createPersona,
                                                                               variables: {
                                                                                   input: payload
                                                                               },
                                                                           });
        console.debug('in the service response', response);

        showSuccessNotification(`${config.titles.singular} created`);
        return response.data?.createPersona;
    } catch (e: any) {

        if (e.errors) {
            // filter out all other messages but the transaction cancelled exception
            e.errors = e.errors.filter((error: {
                errorType: string
            }) => error.errorType === 'DynamoDB:TransactionCanceledException')

            // iterate over the errors and replace the message if it is a duplicate
            e.errors.forEach((error: { errorType: string, message: string }) => {
                if (error.errorType === 'DynamoDB:TransactionCanceledException') {
                    error.message = 'Duplicate persona. please select another'
                }
            });
        }

        console.trace(e);
        showErrorNotifications(e)
    }
};

export const update = async (id: string, record: Persona) => {

    console.debug('IN UPDATE', id, record);

    // Whitelist to the fields UpdatePersonaInput accepts (id, givenName, familyName,
    // email, note, status). Server-managed audit fields (updated/updatedByUsername)
    // are set by the resolver, not the client, so they're intentionally excluded.
    // Sending any other field of the fetched record (created, createdByUsername,
    // recordType, …) makes AppSync reject the whole mutation with "field not defined
    // for input object type 'UpdatePersonaInput'" and NOTHING is written (FNP-764,
    // same class as the FNP-760 alias fix). Whitelist, never blacklist.
    const input = {
        id: record.id,
        givenName: record.givenName,
        familyName: record.familyName,
        email: record.email,
        note: record.note,
        status: record.status,
    };

    try {
        const response = await client.graphql<GraphQLQuery<UpdatePersona>>({
                                                                               query: (updatePersona),
                                                                               variables: {input},
                                                                           });

        showSuccessNotification(`${config.titles.singular} updated`);
        return response.data?.updatePersona;
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e)
    }
};

export const deleteRecord = async (id: string, email: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeletePersona>>({
                                                                               query: (deletePersona),
                                                                               variables: {
                                                                                   input: {
                                                                                       id: id,
                                                                                       email: email,
                                                                                   }
                                                                               },

                                                                           });
        showSuccessNotification(`${config.titles.singular} deleted`);
        return response.data?.deletePersona;
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e)
    }
};
